import React, { forwardRef } from 'react';
import '../styles/tooltips.css';

interface TooltipProps {
    tooltipContent: string | React.ReactNode;
    tooltipDirection: 'right' | 'left' | 'top';
    children: React.ReactNode;
    useSimpleBox?: boolean;
    style?: React.CSSProperties;
    disabled?: boolean;
}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
    if (props.disabled) {
        return <>{props.children}</>;
    }

    const width = props.style?.width || 120;

    return (
        <div className='tooltip'>
            {props.children}
            {props.tooltipDirection == 'left' && (
                <div ref={ref} className={props.useSimpleBox ? 'tooltip-text-left-simple-box' : 'tooltip-text-left'} style={{ ...props.style, width }}>
                    {props.tooltipContent}
                </div>
            )}
            {props.tooltipDirection == 'right' && (
                <div ref={ref} className={props.useSimpleBox ? 'tooltip-text-right-simple-box' : 'tooltip-text-right'} style={{ ...props.style, width }}>
                    {props.tooltipContent}
                </div>
            )}
            {props.tooltipDirection == 'top' && (
                <div ref={ref} className={props.useSimpleBox ? 'tooltip-text-top-simple-box' : 'tooltip-text-top'} style={{ ...props.style, width }}>
                    {props.tooltipContent}
                </div>
            )}
        </div>
    );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
